import { Alert, Stack, Text } from '@mantine/core';
import { IconDevicesPc } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { SectionCard } from './SectionCard';
import { QurilmaJadvali } from './QurilmaJadvali';
import { useAuth } from '../contexts/AuthContext';
import { isTenantDirector, isTenantStaff } from '../lib/permissions';
import type { Qurilma } from '../lib/qurilma';

/**
 * FACE ID → "Qurilmalar" — panelga kirishga ruxsat etilgan maktab kompyuterlari (spec 2026-10-15 §8.5).
 * Direktor: tasdiqlash / rad etish; direktor va admin: bloklash / blokdan chiqarish; buxgalter — faqat ko'radi.
 */
export function QurilmalarKartochkasi() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data = [], isLoading } = useQuery({
    queryKey: ['qurilmalar'],
    queryFn: async () => (await api.get<Qurilma[]>('/qurilma')).data,
    refetchInterval: 30_000, // yangi ulangan kompyuter o'zidan ko'rinsin
  });

  return (
    <SectionCard title={t('qurilma.kartaSarlavha')} icon={IconDevicesPc}>
      <Stack gap="sm">
        <Text size="sm" c="dimmed">{t('qurilma.kartaIzoh')}</Text>
        {!isLoading && data.length === 0 ? (
          <Alert color="gray" variant="light">{t('qurilma.bosh')}</Alert>
        ) : (
          <QurilmaJadvali
            qurilmalar={data}
            huquq={{ tasdiqlay: isTenantDirector(user), bloklay: isTenantStaff(user) }}
            yol={(id, a) => `/qurilma/${id}/${a}`}
            queryKeys={[['qurilmalar']]}
          />
        )}
      </Stack>
    </SectionCard>
  );
}
